import { DEFAULT_COUNTRY } from 'addresses/constants';
import {
  IAddress,
  IAddressForm,
  IContactGroupAddressAutocomplete,
  IStateAutocomplete,
} from 'addresses/types';

import { IUpsertAddressForm } from './types';

export const getDefaultValues = (
  address?: Partial<IContactGroupAddressAutocomplete>
): IUpsertAddressForm => ({
  address: {
    name: address?.name,
    line1: address?.line1,
    line2: address?.line2,
    city: address?.city,
    zip: address?.zip,
    state: address?.stateId
      ? ({
          id: address?.stateId,
          name: address?.stateName,
          abbreviation: address?.stateAbbreviation,
        } as IStateAutocomplete)
      : (address?.state as string),
    country: address?.countryId
      ? {
          id: address?.countryId,
          name: address?.countryName,
          abbreviation: address?.countryAbbreviation,
        }
      : DEFAULT_COUNTRY,
  },
  contactName: address?.contactName,
  contactPhone: address?.contactPhone,
  contactEmail: address?.contactEmail,
  contactCompanyName: address?.contactCompanyName,
});

// The save endpoint returns the state/country as bare abbreviations (e.g. "AR" / "US") without the
// structured stateId/stateName/countryId fields. Re-feeding that response into getDefaultValues
// would fall back to the bare abbreviation, so the State dropdown would show "AR" instead of
// "Arkansas". Merge the structured selections from the just-submitted form back onto the saved
// address so the value round-trips correctly when the edit form is reopened.
export const enrichSavedAddress = (savedAddress: IAddress, formAddress: IAddressForm): IAddress => {
  const state = formAddress?.state as IStateAutocomplete;
  const country = formAddress?.country;

  return {
    ...savedAddress,
    ...(state?.id && {
      stateId: state.id,
      stateName: state.name,
      stateAbbreviation: state.abbreviation,
    }),
    ...(country?.id && {
      countryId: country.id,
      countryName: country.name,
      countryAbbreviation: country.abbreviation,
    }),
  };
};
